import {createAction} from 'redux-actions';
import {STORE_ARTICLE_FETCH} from '../action-types';

export const fetchArticle = createAction(STORE_ARTICLE_FETCH, (query, opts) => v12.article.get(query, opts), query => ({query}));
